import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../../api/axios";

const AddLeaveTypeModal = ({
  showModal,
  onClose,
  onLeaveTypeAdded,
  editLeaveType,
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    short_name: "",
    yearly_limit: "",
    carry_forward_limit: "",
    consider_as: "",
    description: "",
  });

  useEffect(() => {
    if (editLeaveType) {
      setFormData({
        name: editLeaveType.name || "",
        short_name: editLeaveType.short_name || "",
        yearly_limit: editLeaveType.yearly_limit || "",
        carry_forward_limit: editLeaveType.carry_forward_limit || "",
        consider_as: editLeaveType.consider_as || "",
        description: editLeaveType.description || "",
      });
    }
  }, [editLeaveType]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      setLoading(true);

      const res = editLeaveType
        ? await api.put(`/hrms/leave-types/${editLeaveType.id}`, formData)
        : await api.post("/hrms/leave-types", formData);

      Swal.fire({
        title: "Success!",
        text: editLeaveType
          ? "LeaveType updated successfully!"
          : "LeaveType added successfully!",
        icon: "success",
        timer: 1200,
        showConfirmButton: false,
      });
      if (onLeaveTypeAdded) onLeaveTypeAdded();
      onClose();
      setFormData({
        name: "",
        short_name: "",
        yearly_limit: "",
        carry_forward_limit: "",
        consider_as: "",
        description: "",
      });
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.response?.data?.message || "Failed to save leaveType",
        icon: "error",
        confirmButtonText: "OK",
      });
      // Modal stays open on error
    } finally {
      setLoading(false);
    }
  };

  if (!showModal) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content border-0 shadow-lg rounded-3">
          <div className="modal-header bg-dark text-white">
            <h5 className="modal-title">
              {editLeaveType ? "Edit Leave Type" : "Add New Leave Type"}
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body">
            <div className="d-flex gap-3">
              <div className="mb-3 flex-fill">
                <label className="form-label">Leave Type Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3 flex-fill">
                <label className="form-label">Short Name</label>
                <input
                  type="text"
                  name="short_name"
                  className="form-control"
                  value={formData.short_name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="d-flex gap-3">
              <div className="mb-3 flex-fill">
                <label className="form-label">Yearly Limit</label>
                <input
                  type="number"
                  name="yearly_limit"
                  className="form-control"
                  value={formData.yearly_limit}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3 flex-fill">
                <label className="form-label">Carry Forward Limit</label>
                <input
                  type="number"
                  name="carry_forward_limit"
                  className="form-control"
                  value={formData.carry_forward_limit}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="d-flex gap-3">
              <div className="mb-3 flex-fill">
                <label className="form-label">Consider As</label>
                <input
                  type="text"
                  name="consider_as"
                  className="form-control"
                  value={formData.consider_as}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3 flex-fill">
                <label className="form-label">Description</label>
                <input
                  type="text"
                  name="description"
                  className="form-control"
                  value={formData.description}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary d-flex align-items-center gap-2 py-2 px-3 mt-4"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn add-emp-btn d-flex align-items-center gap-2 py-2 px-3 mt-4"
              onClick={handleSave}
              disabled={loading}
            >
              {loading
                ? "Saving..."
                : editLeaveType
                ? "Update Leave Type"
                : "Save Leave Type"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddLeaveTypeModal;
